import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Shield, Flame, Users } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute left-1/2 top-1/2 w-[700px] h-[700px] bg-gradient-to-r from-amber-100/50 to-orange-100/50 rounded-full blur-[150px] -translate-x-1/2 -translate-y-1/2" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
            Ready to Join the Revolution?
          </h2>
          <p className="text-gray-500 text-lg sm:text-xl max-w-2xl mx-auto mb-10">
            Don't miss out on the next big meme coin. White Shiba Inu is just getting started.
          </p>

          {/* CTA Button */}
          <motion.a
            href="https://jup.ag/?buy=5yMU4CEnjfT37mEaFFnPTWwy1YC23GvVjJxuLzPTpump"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-flex items-center gap-2 px-10 py-5 bg-gray-900 text-white rounded-full font-semibold text-lg shadow-lg hover:bg-gray-800 transition-all mb-10"
          >
            Buy $WhiteShiba Now
            <ArrowRight size={20} />
          </motion.a>

          {/* Trust badges */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex flex-wrap items-center justify-center gap-4 sm:gap-8"
          >
            <div className="flex items-center gap-2 text-gray-600">
              <Shield className="w-5 h-5 text-amber-500" />
              <span className="text-sm font-medium">Audited Contract</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <Flame className="w-5 h-5 text-amber-500" />
              <span className="text-sm font-medium">Liquidity Burned</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <Users className="w-5 h-5 text-amber-500" />
              <span className="text-sm font-medium">No Team Tokens</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
